angular.module('st')
    .controller('crewardsWatchlistController', [
        '$rootScope', '$scope', '$http', '$filter',
        function ($rootScope, $scope, $http, $filter) {
            var ctrl = this;
            $scope.removeFilmFeedback = '';
            $scope.removeFilmProcessing = false;
            $scope.removeShowFeedback = '';
            $scope.removeShowProcessing = false;
            $scope.watchlist = [];

            ctrl.SetWatchlist = function (watchlistIDs) {
                $scope.watchlist = watchlistIDs;
            }

            ctrl.GoToEditEmail = function () {
                $('a[aria-controls="my account"]').click();
            }

            ctrl.RemoveFilm = function (filmCode, event) {
                if ($scope.removeFilmProcessing == false) {
                    $scope.removeFilmProcessing = true;
                    $scope.removeFilmFeedback = '';

                    $http.post("/rpc/membership/account/watchlist/remove/" + filmCode)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                // success
                                $scope.removeFilmFeedback = '';
                                $scope.removeFilmProcessing = false;

                                var index = $scope.watchlist.indexOf(filmCode);
                                $scope.watchlist.splice(index, 1);
                                
                                // remove movie from the carousel
                                var length = $scope.watchlist.length;
                                if (length >=4) {                                    
                                    var a = event.target;
                                    var slickIndex = $(a).closest('.watchlist-item').data('slick-index');
                                    var jQueryIndex = $('.movie-poster-carousel').index(a);

                                    $('.carousel-watchlist-item[data-slick-index="' + slickIndex + '"]').attr('style', 'display: none !important;');
                                    $('.movie-poster-carousel').slick('slickRemove', jQueryIndex);
                                } else {
                                    $('.arrows').removeClass('d-md-flex');
                                    $('.movie-poster-carousel').slick('unslick');
                                }
                            } else {
                                // vista error
                                $scope.removeFilmProcessing = false;
                                $scope.removeFilmFeedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.removeFilmProcessing = false;
                            $scope.removeFilmFeedback = 'Error occurred while trying to remove film.'
                        })
                }
            }

            ctrl.RemoveShow = function (showCode, event) {
                event.preventDefault();

                if ($scope.removeShowProcessing == false) {
                    $scope.removeShowProcessing = true;
                    $scope.removeShowFeedback = '';

                    $http.post("/rpc/membership/account/shows/remove/" + showCode)
                         .then(function (data) {
                            if (data.data.Success == true) {
                                // success
                                $scope.removeShowFeedback = '';
                                $scope.removeShowProcessing = false;

                                var index = $scope.watchlist.indexOf(showCode);
                                $scope.watchlist.splice(index, 1);

                                var length = $scope.watchlist.length;

                                if (length >=3) {     
                                    var a = event.target;

                                    var slickIndex = $(a).closest('.watchlist-item').data('slick-index');
                                    var jQueryIndex = $('main div[data-slick-index="' + slickIndex + '"]').index()
                          
                                    $('main .carousel-watchlist-item[data-slick-index="' + slickIndex + '"]').attr('style', 'display: none !important;');
                                    $('main .watchlist-carousel .row').slick('slickRemove', jQueryIndex);

                                    if(length == 3){
                                        $('.watchlist-carousel').removeClass('d-md-block');
                                        $('.watchlist-static').removeClass('d-md-none');
                                        $('.arrows-and-text').css('display', 'none');
                                    }
                                } 
                            } else {
                                // vista error
                                $scope.removeShowProcessing = false;
                                $scope.removeShowFeedback = 'Error: ' + data.data.Message;
                                alert('Error: ' + data.data.Message);
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.removeShowProcessing = false;
                            $scope.removeShowFeedback = 'Error occurred while trying to remove show.'
                            alert('Error occurred while trying to remove show.');
                        })
                }
            }
        }
    ]);
